import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

const SEV_RENK: Record<number, string> = { 0: '#1a5276', 1: '#1e8449', 2: '#7d6608' };
const SEV_ETIKET: Record<number, string> = { 0: '1. Bar', 1: '2. Bar', 2: 'Sidebar' };

const IKON_LISTESI = [
  '🏠','📋','🐄','🐑','🐴','🐝','🦌','🐕','🌾','🌿','🌳',
  '💰','📊','📈','🏭','🏗️','🚜','⚙️','👤','🔐','🗂️','🔗',
  '📁','📌','🔧','🛠️','📦','🏆','⭐','✅','🔔','💡','🌐',
  '📅','🗓️','📝','🖊️','🔍','💼','🏢','🌱','🍃','🐾',
];

const YETKI_GRUPLARI = [
  'ANA SAYFA', 'KURUM', 'HAYVANCILIK', 'BİTKİSEL ÜRETİM',
  'VARLIK YÖNETİMİ', 'RAPORLAMA', 'SİSTEM', 'BİLGİ NOTU',
  'ZİYARET', 'YBS',
];

const BOŞ_FORM = {
  kod: '', ust_kod: '', ad: '', ikon: '',
  modul_baglantisi: '', route: '', sira: 0, aktif: 1,
  yetkilendirilebilir: false, yetki_grubu: '',
};

function seviye(kod: string, ustMap: Record<string, string | null>): number {
  let s = 0, k = kod;
  while (ustMap[k]) { k = ustMap[k]!; s++; if (s > 5) break; }
  return s;
}

function kodKarsilastir(a: string, b: string): number {
  const ap = a.split('.');
  const bp = b.split('.');
  const len = Math.max(ap.length, bp.length);
  for (let i = 0; i < len; i++) {
    if (!ap[i]) return -1;
    if (!bp[i]) return 1;
    const an = parseInt(ap[i]);
    const bn = parseInt(bp[i]);
    if (!isNaN(an) && !isNaN(bn)) {
      if (an !== bn) return an - bn;
    } else {
      if (ap[i] < bp[i]) return -1;
      if (ap[i] > bp[i]) return 1;
    }
  }
  return 0;
}

export default function MenuYonetimi() {
  const _user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = ['super_admin', 'gm_yonetici'].includes(_user?.rol);

  const [tumSayfalar, setTumSayfalar] = useState<any[]>([]);
  const [liste,       setListe]       = useState<any[]>([]);
  const [ustMap,      setUstMap]      = useState<Record<string, string | null>>({});
  const [yukl,        setYukl]        = useState(true);
  const [mesaj,       setMesaj]       = useState('');
  const [hata,        setHata]        = useState('');
  const [modalAcik,   setModalAcik]   = useState(false);
  const [duzenleme,   setDuzenleme]   = useState(false);
  const [seciliId,    setSeciliId]    = useState<number|null>(null);
  const [form,        setForm]        = useState({ ...BOŞ_FORM });
  const [silOnay,     setSilOnay]     = useState<any>(null);
  const [dragIdx,     setDragIdx]     = useState<number|null>(null);
  const [dragOverIdx, setDragOverIdx] = useState<number|null>(null);
  const [degisti,     setDegisti]     = useState(false);

  useEffect(() => { yukle(); yukleSayfalar(); }, []);

  const yukleSayfalar = async () => {
    try {
      const rs = await fetch(`${API}/api/sayfa-route/sayfalar`, { headers: hdr() });
      if (rs.ok) setTumSayfalar(await rs.json());
    } catch {}
  };

  const yukle = async () => {
    setYukl(true);
    const r = await fetch(`${API}/api/menu-agac/liste`, { headers: hdr() });
    if (r.ok) {
      const d = await r.json();
      const map: Record<string, string | null> = {};
      (d.liste || []).forEach((x: any) => { map[x.kod] = x.ust_kod; });
      setUstMap(map);
      setListe((d.liste || []).map((x: any) => ({ ...x, _sev: seviye(x.kod, map) })));
      setDegisti(false);
    }
    setYukl(false);
  };

  const bildir = (msg: string, tip = 'ok') => {
    if (tip === 'ok') { setMesaj(msg); setTimeout(() => setMesaj(''), 3000); }
    else              { setHata(msg);  setTimeout(() => setHata(''), 4000); }
  };

  const yeniAc = () => {
    setForm({ ...BOŞ_FORM });
    setDuzenleme(false);
    setSeciliId(null);
    setModalAcik(true);
  };

  const sonrakiSira = (ust_kod: string) => {
    const kardesler = liste.filter(x => (x.ust_kod || '') === ust_kod);
    if (kardesler.length === 0) return 1;
    return Math.max(...kardesler.map(x => x.sira || 0)) + 1;
  };

  const duzenleAc = (item: any) => {
    setForm({
      kod: item.kod, ust_kod: item.ust_kod || '',
      ad: item.ad, ikon: item.ikon || '',
      modul_baglantisi: item.modul || '', route: item.route || '',
      sira: item.sira || 0, aktif: item.aktif ?? 1,
      yetkilendirilebilir: item.yetkilendirilebilir || false,
      yetki_grubu: item.yetki_grubu || '',
    });
    setDuzenleme(true);
    setSeciliId(item.id);
    setModalAcik(true);
  };

  const siraTopluGonder = async (siralanmis: any[]) => {
    const updates = siralanmis.map((item, idx) => ({ id: item.id, sira: idx + 1 }));
    const r = await fetch(`${API}/api/menu-agac/sira-toplu`, {
      method: 'PUT', headers: hdr(), body: JSON.stringify(updates),
    });
    return r.ok;
  };

  const kaydet = async () => {
    if (!form.kod.trim() || !form.ad.trim()) {
      bildir('Kod ve Ad zorunludur!', 'hata'); return;
    }
    const body = {
      kod: form.kod.trim(), ust_kod: form.ust_kod || null,
      ad: form.ad.trim(), ikon: form.ikon || null,
      modul_baglantisi: form.modul_baglantisi || null,
      route: form.route || null, sira: Number(form.sira), aktif: Number(form.aktif),
      yetkilendirilebilir: form.yetkilendirilebilir,
      yetki_grubu: form.yetki_grubu || null,
    };
    const url    = duzenleme ? `${API}/api/menu-agac/${seciliId}` : `${API}/api/menu-agac/ekle`;
    const method = duzenleme ? 'PUT' : 'POST';
    const r = await fetch(url, { method, headers: hdr(), body: JSON.stringify(body) });
    if (r.ok) {
      setModalAcik(false);
      if (!duzenleme) {
        // Yeni kayıt: listeyi yükle sonra koda göre sırala ve kaydet
        const r2 = await fetch(`${API}/api/menu-agac/liste`, { headers: hdr() });
        if (r2.ok) {
          const d = await r2.json();
          const map: Record<string, string | null> = {};
          (d.liste || []).forEach((x: any) => { map[x.kod] = x.ust_kod; });
          setUstMap(map);
          const yeniListe = (d.liste || []).map((x: any) => ({ ...x, _sev: seviye(x.kod, map) }));
          const sorted = [...yeniListe].sort((a, b) => kodKarsilastir(a.kod, b.kod));
          await siraTopluGonder(sorted);
          setListe(sorted.map((item, idx) => ({ ...item, sira: idx + 1 })));
          setDegisti(false);
          bildir('✅ Eklendi, otomatik sıralandı');
          window.dispatchEvent(new Event('menu-guncellendi'));
        }
      } else {
        bildir('✅ Güncellendi');
        window.dispatchEvent(new Event('menu-guncellendi'));
        yukle();
      }
    } else {
      const err = await r.json().catch(() => ({}));
      bildir(err.detail || '❌ Kayıt hatası', 'hata');
    }
  };

  const sil = async (item: any) => {
    const r = await fetch(`${API}/api/menu-agac/${item.id}`, { method: 'DELETE', headers: hdr() });
    if (r.ok) { bildir('✅ Silindi'); setSilOnay(null); yukle(); }
    else {
      const err = await r.json().catch(() => ({}));
      bildir(err.detail || '❌ Silme hatası', 'hata'); setSilOnay(null);
    }
  };

  const siraGuncelle = async () => {
    const ok = await siraTopluGonder(liste);
    if (ok) {
      setDegisti(false);
      bildir('✅ Sıralar kaydedildi');
      window.dispatchEvent(new Event('menu-guncellendi'));
      await yukle();
    } else {
      bildir('❌ Güncelleme hatası', 'hata');
    }
  };

  const kodaGoreSirala = async () => {
    const sorted = [...liste].sort((a, b) => kodKarsilastir(a.kod, b.kod));
    const ok = await siraTopluGonder(sorted);
    if (ok) {
      setDegisti(false);
      bildir('✅ Koda göre sıralandı ve kaydedildi');
      window.dispatchEvent(new Event('menu-guncellendi'));
      await yukle();
    } else {
      bildir('❌ Kaydetme başarısız', 'hata');
    }
  };

  // Sürükle-bırak: alt ağaç birlikte taşınır
  const handleDrop = (dropIdx: number) => {
    if (dragIdx === null || dragIdx === dropIdx) {
      setDragIdx(null); setDragOverIdx(null); return;
    }
    const draggedKod = liste[dragIdx].kod;
    const isAltAgac  = (kod: string) => kod === draggedKod || kod.startsWith(draggedKod + '.');

    if (isAltAgac(liste[dropIdx].kod)) {
      setDragIdx(null); setDragOverIdx(null); return;
    }

    const altAgac    = liste.filter(item =>  isAltAgac(item.kod));
    const digerler   = liste.filter(item => !isAltAgac(item.kod));
    const eklePos    = digerler.findIndex(item => item.id === liste[dropIdx].id);

    const yeniListe  = [
      ...digerler.slice(0, eklePos),
      ...altAgac,
      ...digerler.slice(eklePos),
    ];

    setListe(yeniListe);
    setDragIdx(null);
    setDragOverIdx(null);
    setDegisti(true);
  };

  const dragSatirStil = (i: number): React.CSSProperties => {
    const isDragging = dragIdx !== null && (
      liste[i].kod === liste[dragIdx]?.kod ||
      liste[i].kod.startsWith((liste[dragIdx]?.kod || '___') + '.')
    );
    const isOver = dragOverIdx === i;
    return {
      background:    isOver    ? '#dbeafe' : (i % 2 === 0 ? '#fff' : '#f9fbfd'),
      borderBottom:  isOver    ? '2px solid #2563eb' : '1px solid #f0f0f0',
      opacity:       isDragging ? 0.4 : 1,
      transition:    'background 0.1s',
    };
  };

  return (
    <div>
      <div className="page-header">
        <h1>🗂️ Menü Yönetimi</h1>
        <p><strong>menu_agac</strong> tablosunu buradan yönetin.</p>
      </div>

      {mesaj && <div style={{ background:'#d5f5e3', color:'#1e8449', padding:'10px 14px', borderRadius:4, marginBottom:16, fontSize:13 }}>{mesaj}</div>}
      {hata  && <div style={{ background:'#fdedec', color:'#c0392b', padding:'10px 14px', borderRadius:4, marginBottom:16, fontSize:13 }}>{hata}</div>}

      <div className="card" style={{ padding:0 }}>
        <div style={{ padding:'12px 16px', borderBottom:'1px solid #eee', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
          {isAdmin && <button className="btn btn-primary" onClick={yeniAc} style={{ fontSize:13 }}>➕ Yeni Kayıt</button>}
          <button className="btn btn-sm" onClick={yukle} style={{ background:'#eee', fontSize:12 }}>🔄 Yenile</button>
          {isAdmin && <button className="btn btn-sm" onClick={kodaGoreSirala} style={{ background:'#eaf2fb', color:'#1a5276', fontSize:12 }}>🔤 Koda Göre Sırala</button>}
          {isAdmin && degisti && (
            <button onClick={siraGuncelle} style={{ fontSize:12, padding:'5px 12px', background:'#e67e22', color:'white', border:'none', borderRadius:4, cursor:'pointer', fontWeight:600 }}>
              💾 Sıraları Kaydet
            </button>
          )}
          <div style={{ marginLeft:'auto', fontSize:12, color:'#888' }}>Toplam: <strong>{liste.length}</strong> kayıt</div>
        </div>

        {yukl ? (
          <div style={{ padding:40, textAlign:'center', color:'#aaa' }}>Yükleniyor...</div>
        ) : (
          <>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
              <thead>
                <tr style={{ background:'#f0f4f8' }}>
                  <th style={{ width:24 }}></th>
                  {['Kod','Ad','Seviye','Üst','İkon','Route','Sıra','Aktif','İşlem'].map(h => (
                    <th key={h} style={{ padding:'8px 12px', textAlign: h==='Sıra'||h==='Aktif'||h==='İşlem'?'center':'left', fontWeight:600 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {liste.length === 0 && (
                  <tr><td colSpan={10} style={{ padding:32, textAlign:'center', color:'#aaa' }}>
                    Kayıt yok. ➕ Yeni Kayıt ile başlayın.
                  </td></tr>
                )}
                {liste.map((item, i) => (
                  <tr
                    key={item.id}
                    draggable
                    onDragStart={() => setDragIdx(i)}
                    onDragOver={e => { e.preventDefault(); setDragOverIdx(i); }}
                    onDragLeave={() => setDragOverIdx(null)}
                    onDrop={e => { e.preventDefault(); handleDrop(i); }}
                    onDragEnd={() => { setDragIdx(null); setDragOverIdx(null); }}
                    style={dragSatirStil(i)}
                  >
                    <td style={{ padding:'4px 4px 4px 8px', color:'#ccc', cursor:'grab', userSelect:'none', fontSize:14, textAlign:'center' }} title="Sürükleyerek taşı">⠿</td>
                    <td style={{ padding:'7px 12px', fontWeight:700, color:SEV_RENK[item._sev]||'#333', paddingLeft:12+item._sev*16 }}>{item.kod}</td>
                    <td style={{ padding:'7px 12px' }}>{item.ad}</td>
                    <td style={{ padding:'7px 12px' }}>
                      <span style={{ fontSize:10, background:'#eee', padding:'2px 6px', borderRadius:3, color:SEV_RENK[item._sev]||'#555' }}>
                        {SEV_ETIKET[item._sev]||`S${item._sev}`}
                      </span>
                    </td>
                    <td style={{ padding:'7px 12px', color:'#777', fontSize:11 }}>{item.ust_kod||'—'}</td>
                    <td style={{ padding:'7px 12px', fontSize:16 }}>{item.ikon||'—'}</td>
                    <td style={{ padding:'7px 12px', fontFamily:'monospace', fontSize:11, color:item.route?'#1a5276':'#bbb' }}>
                      {item.route||'—'}
                      {item.yetkilendirilebilir && <span title={`Yetki Grubu: ${item.yetki_grubu||'—'}`} style={{ marginLeft:4, fontSize:12 }}>🔐</span>}
                    </td>
                    <td style={{ padding:'7px 4px', textAlign:'center', fontSize:11, color:'#999' }}>{item.sira}</td>
                    <td style={{ padding:'7px 12px', textAlign:'center', fontSize:13 }}>{item.aktif?'✅':'⛔'}</td>
                    <td style={{ padding:'7px 8px', textAlign:'center' }}>
                      {isAdmin && (
                        <div style={{ display:'flex', gap:4, justifyContent:'center' }}>
                          <button className="btn btn-sm" style={{ fontSize:11, padding:'2px 8px', background:'#eaf2fb', color:'#1a5276' }} onClick={() => duzenleAc(item)}>Düzenle</button>
                          <button className="btn btn-sm" style={{ fontSize:11, padding:'2px 8px', background:'#fdedec', color:'#c0392b' }} onClick={() => setSilOnay(item)}>Sil</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {isAdmin && degisti && (
              <div style={{ padding:'10px 16px', background:'#fff7ed', borderTop:'1px solid #fed7aa', display:'flex', alignItems:'center', gap:8, fontSize:12 }}>
                <span style={{ color:'#92400e' }}>⚠️ Sıralama değişti, henüz kaydedilmedi.</span>
                <button onClick={siraGuncelle} style={{ marginLeft:'auto', fontSize:12, padding:'5px 14px', background:'#e67e22', color:'white', border:'none', borderRadius:4, cursor:'pointer', fontWeight:600 }}>
                  💾 Sıraları Kaydet
                </button>
                <button onClick={() => { setDegisti(false); yukle(); }} style={{ fontSize:12, padding:'4px 10px', background:'#eee', border:'1px solid #ddd', borderRadius:4, cursor:'pointer' }}>
                  ↩ Geri Al
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* EKLE / DÜZENLE MODAL */}
      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width:520 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{duzenleme ? '✏️ Düzenle' : '➕ Yeni Menü Kaydı'}</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>✕</button>
            </div>
            <div className="modal-body">

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <div className="form-group">
                  <label style={{ fontSize:12 }}>Kod *</label>
                  <input className="form-control" value={form.kod}
                    onChange={e => setForm({...form, kod: e.target.value})}
                    placeholder="örn: U, U.1, U.1.1" disabled={duzenleme} />
                  {duzenleme && <div style={{ fontSize:10, color:'#aaa', marginTop:2 }}>Kod değiştirilemez</div>}
                </div>
                <div className="form-group">
                  <label style={{ fontSize:12 }}>Üst Menü Kodu</label>
                  <select className="form-control" value={form.ust_kod}
                    onChange={e => {
                      const yeniUst = e.target.value;
                      setForm({...form, ust_kod: yeniUst, sira: duzenleme ? form.sira : sonrakiSira(yeniUst)});
                    }}>
                    <option value="">— Yok (1. Bar) —</option>
                    {liste.filter(x => x._sev < 2).map(u => (
                      <option key={u.kod} value={u.kod}>{'  '.repeat(u._sev)}{u.kod} – {u.ad}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label style={{ fontSize:12 }}>Ad *</label>
                <input className="form-control" value={form.ad}
                  onChange={e => setForm({...form, ad: e.target.value})} placeholder="Menü başlığı" />
              </div>

              <div className="form-group">
                <label style={{ fontSize:12 }}>İkon</label>
                <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                  <select className="form-control" value={form.ikon}
                    onChange={e => setForm({...form, ikon: e.target.value})} style={{ flex:1 }}>
                    <option value="">— İkon yok —</option>
                    {IKON_LISTESI.map(ikon => (
                      <option key={ikon} value={ikon}>{ikon}</option>
                    ))}
                  </select>
                  <span style={{ fontSize:28, minWidth:36, textAlign:'center' }}>{form.ikon}</span>
                </div>
              </div>

              <div className="form-group">
                <label style={{ fontSize:12 }}>Route (Sayfa Bağlantısı)</label>
                <select className="form-control" value={form.route}
                  onChange={e => setForm({...form, route: e.target.value})}>
                  <option value="">— Bağlantı yok —</option>
                  {tumSayfalar.map(s => (
                    <option key={s.route} value={s.route}>{s.ad}  →  {s.route}</option>
                  ))}
                </select>
                {form.route && (
                  <div style={{ fontSize:11, color:'#1a5276', fontFamily:'monospace', marginTop:4 }}>{form.route}</div>
                )}
              </div>

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <div className="form-group">
                  <label style={{ fontSize:12 }}>Sıra</label>
                  <input className="form-control" type="number" value={form.sira}
                    onChange={e => setForm({...form, sira: Number(e.target.value)})} />
                </div>
                <div className="form-group">
                  <label style={{ fontSize:12 }}>Aktif</label>
                  <select className="form-control" value={form.aktif}
                    onChange={e => setForm({...form, aktif: Number(e.target.value)})}>
                    <option value={1}>✅ Aktif</option>
                    <option value={0}>⛔ Pasif</option>
                  </select>
                </div>
              </div>

              {/* Yetki Matrisi */}
              <div style={{ marginTop:4, padding:'10px 12px', background:'#f0f4f8', borderRadius:6, border:'1px solid #dde3ec' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom: form.yetkilendirilebilir ? 10 : 0 }}>
                  <label style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', fontSize:13, fontWeight:600, color:'#1a5276' }}>
                    <input
                      type="checkbox"
                      checked={form.yetkilendirilebilir}
                      onChange={e => setForm({...form, yetkilendirilebilir: e.target.checked, yetki_grubu: e.target.checked ? form.yetki_grubu : ''})}
                    />
                    🔐 Yetki Matrisinde Göster
                  </label>
                  <span style={{ fontSize:11, color:'#888' }}>Bu menü, yetkilendirme sayfasında bir modül olarak görünsün</span>
                </div>
                {form.yetkilendirilebilir && (
                  <div className="form-group" style={{ marginBottom:0 }}>
                    <label style={{ fontSize:12 }}>Modül ID <span style={{ color:'#e67e22' }}>*</span></label>
                    <input className="form-control" value={form.modul_baglantisi}
                      onChange={e => setForm({...form, modul_baglantisi: e.target.value})}
                      placeholder="örn: buyukbas, dashboard, tanimlar" />
                    <div style={{ fontSize:10, color:'#888', marginTop:2 }}>Yetki tablosundaki satır anahtarı — var olan modüllerle aynı ID olmalı</div>
                    <label style={{ fontSize:12, marginTop:8, display:'block' }}>Yetki Grubu <span style={{ color:'#e67e22' }}>*</span></label>
                    <select className="form-control" value={form.yetki_grubu}
                      onChange={e => setForm({...form, yetki_grubu: e.target.value})}>
                      <option value="">— Grup seçin —</option>
                      {YETKI_GRUPLARI.map(g => <option key={g} value={g}>{g}</option>)}
                    </select>
                  </div>
                )}
              </div>

            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background:'#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet}>💾 Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* SİL ONAYI */}
      {silOnay && (
        <div className="modal-overlay" onClick={() => setSilOnay(null)}>
          <div className="modal" style={{ width:360 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>⚠️ Silme Onayı</h3>
              <button className="modal-close" onClick={() => setSilOnay(null)}>✕</button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize:13 }}><strong>{silOnay.kod} – {silOnay.ad}</strong> silinsin mi?</p>
              <p style={{ fontSize:11, color:'#e67e22', marginTop:8 }}>⚠️ Alt kaydı olan öğe silinemez.</p>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setSilOnay(null)} style={{ background:'#eee' }}>İptal</button>
              <button className="btn" onClick={() => sil(silOnay)} style={{ background:'#c0392b', color:'white' }}>🗑️ Sil</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
